// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gpp3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModuleContextProvider", function() {
    return ModuleContextProvider;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moduleContext = require("./module-context");
var brandLoaders = {
    peugeot: function() {
        return require("cd786384532cc931");
    },
    ds: function() {
        return require("2ffff2baa771d875");
    },
    citroen: function() {
        return require("272d84b04f4b9b13");
    },
    opel: function() {
        return require("cc7f87a9f07a0bc3");
    },
    opelold: function() {
        return require("feda7adbb4179546");
    },
    admin: function() {
        return require("9330c46a848529dc");
    },
    ssangyong: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(customData) {
            var module, loadSsangyong;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            require("9dc8ff74bfc4f8d8")
                        ];
                    case 1:
                        module = _state.sent();
                        loadSsangyong = module.default;
                        return [
                            2,
                            loadSsangyong(customData)
                        ];
                }
            });
        });
        return function(customData) {
            return _ref.apply(this, arguments);
        };
    }(),
    isuzu: function() {
        return require("8852e5e7783e0517");
    },
    fiat: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isFiatPro) {
            var module, loadFiat;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            require("ce42576e84ed069b")
                        ];
                    case 1:
                        module = _state.sent();
                        loadFiat = module.default;
                        return [
                            2,
                            loadFiat(isFiatPro)
                        ];
                }
            });
        });
        return function(isFiatPro) {
            return _ref.apply(this, arguments);
        };
    }(),
    jeep: function() {
        return require("fc11f29e79eaeff5");
    },
    alfaromeo: function() {
        return require("62451695aae2fe6f");
    },
    abarth: function() {
        return require("54134e418bf2880a");
    },
    lancia: function() {
        return require("47531eab10c9533e");
    },
    ai: function() {
        return require("f83b11b821c72259");
    },
    petranyi: function() {
        return require("e667830588afd3bf");
    }
};
var loadModuleContext = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(props) {
        var brandDescriptor, _ref, modules, theme, module;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        brandLoaders[(props.adminMode ? 'admin' : props.brand === 'opelnew' ? 'opelold' : props.brand) || 'opel'](props.customData)
                    ];
                case 1:
                    brandDescriptor = _state.sent();
                    _ref = (0, _slicedToArray._)(brandDescriptor.default || brandDescriptor, 2), modules = _ref[0], theme = _ref[1];
                    module = modules.find(function(m) {
                        return m.externalName === props.moduleName;
                    });
                    if (!module) throw new Error('Unrecognized module name: ' + props.moduleName);
                    return [
                        2,
                        {
                            module: module,
                            basetheme: theme
                        }
                    ];
            }
        });
    });
    return function loadModuleContext(props) {
        return _ref.apply(this, arguments);
    };
}();
var ModuleContextProvider = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), context = _useState[0], setContext = _useState[1];
    (0, _react.useEffect)(function() {
        loadModuleContext(props).then(function(moduleContext) {
            return setContext(moduleContext);
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moduleContext.ModuleContext).Provider, {
        value: context,
        children: props.children
    });
};

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_ts_generator":"dGETY","react/jsx-runtime":"lhkWg","react":"gjea9","./module-context":"6LTxE","cd786384532cc931":"4N1BZ","2ffff2baa771d875":"3yhrE","272d84b04f4b9b13":"6ndt2","cc7f87a9f07a0bc3":"aFrS9","feda7adbb4179546":"g65XC","9330c46a848529dc":"7qor2","9dc8ff74bfc4f8d8":"5lVsG","8852e5e7783e0517":"cYkVy","ce42576e84ed069b":"1xBhy","fc11f29e79eaeff5":"e1Ewh","62451695aae2fe6f":"7NjCZ","54134e418bf2880a":"cRTSJ","47531eab10c9533e":"dk30C","f83b11b821c72259":"ihC5o","e667830588afd3bf":"kvdzY","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"5Sh31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"kWbq7","./_iterable_to_array_limit.js":"Ggisl","./_non_iterable_rest.js":"hkEdH","./_unsupported_iterable_to_array.js":"cEWsJ","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"kWbq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"Ggisl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"hkEdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"4N1BZ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("e14642c2266bf53b")(require("55a26926b9774c5d").resolve("lBKHP")),
    require("e14642c2266bf53b")(require("55a26926b9774c5d").resolve("gnOWr")),
    require("c68ee30f31a2b548")(require("55a26926b9774c5d").resolve("1N2hL"))
]).then(function() {
    return module.bundle.root('dpFgZ');
});

},{"e14642c2266bf53b":"fTgEh","55a26926b9774c5d":"aiVrJ","c68ee30f31a2b548":"aJpgn"}],"fTgEh":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"16cXL"}],"3yhrE":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("dba3e06ea8239728")(require("9de02eae451ad7fc").resolve("38qZh")),
    require("dba3e06ea8239728")(require("9de02eae451ad7fc").resolve("lBKHP")),
    require("b0173a96e13db336")(require("9de02eae451ad7fc").resolve("kfiiH"))
]).then(function() {
    return module.bundle.root('3qvR4');
});

},{"dba3e06ea8239728":"fTgEh","9de02eae451ad7fc":"aiVrJ","b0173a96e13db336":"aJpgn"}],"6ndt2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("51b9232e7ed7314")(require("8bb46b7749b9793a").resolve("z2wcZ")),
    require("51b9232e7ed7314")(require("8bb46b7749b9793a").resolve("lBKHP")),
    require("ad6253b224294948")(require("8bb46b7749b9793a").resolve("csQew"))
]).then(function() {
    return module.bundle.root('856N5');
});

},{"51b9232e7ed7314":"fTgEh","8bb46b7749b9793a":"aiVrJ","ad6253b224294948":"aJpgn"}],"aFrS9":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("cd41dc585ac61475")(require("f6a6afe3c64c8866").resolve("lRpWV")),
    require("cd41dc585ac61475")(require("f6a6afe3c64c8866").resolve("lBKHP")),
    require("78c8e0b853027bdb")(require("f6a6afe3c64c8866").resolve("gDes9"))
]).then(function() {
    return module.bundle.root('1D0f9');
});

},{"cd41dc585ac61475":"fTgEh","f6a6afe3c64c8866":"aiVrJ","78c8e0b853027bdb":"aJpgn"}],"g65XC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("50f8bd5548c5dcc5")(require("d524bb2123a656d6").resolve("ltsaV")),
    require("50f8bd5548c5dcc5")(require("d524bb2123a656d6").resolve("lBKHP")),
    require("2e75d7a1fd53c984")(require("d524bb2123a656d6").resolve("a2irY"))
]).then(function() {
    return module.bundle.root('B22Ef');
});

},{"50f8bd5548c5dcc5":"fTgEh","d524bb2123a656d6":"aiVrJ","2e75d7a1fd53c984":"aJpgn"}],"7qor2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("3607b7cfa4642d76")(require("30b935fb6469d34c").resolve("jACzd")),
    require("3607b7cfa4642d76")(require("30b935fb6469d34c").resolve("lBKHP")),
    require("1e4e891b7ec70bbb")(require("30b935fb6469d34c").resolve("ezMNG"))
]).then(function() {
    return module.bundle.root('jAt29');
});

},{"3607b7cfa4642d76":"fTgEh","30b935fb6469d34c":"aiVrJ","1e4e891b7ec70bbb":"aJpgn"}],"5lVsG":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("d2809ba9db38f0cd")(require("edaac097905d2b05").resolve("dOUmD")),
    require("d2809ba9db38f0cd")(require("edaac097905d2b05").resolve("lBKHP")),
    require("fb76d6d82adc451c")(require("edaac097905d2b05").resolve("8GUZz"))
]).then(function() {
    return module.bundle.root('jcFqG');
});

},{"d2809ba9db38f0cd":"fTgEh","edaac097905d2b05":"aiVrJ","fb76d6d82adc451c":"aJpgn"}],"cYkVy":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("7c7a833cb8bcccac")(require("756ff951565cac1b").resolve("hO7DN")),
    require("7c7a833cb8bcccac")(require("756ff951565cac1b").resolve("lBKHP")),
    require("d4f7cf12031416d9")(require("756ff951565cac1b").resolve("4J9Qz"))
]).then(function() {
    return module.bundle.root('6eCc9');
});

},{"7c7a833cb8bcccac":"fTgEh","756ff951565cac1b":"aiVrJ","d4f7cf12031416d9":"aJpgn"}],"1xBhy":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("fa110917f8de966e")(require("2a9a39dde91eb6df").resolve("3LLmw")),
    require("fa110917f8de966e")(require("2a9a39dde91eb6df").resolve("lBKHP")),
    require("b6071a2c894768d9")(require("2a9a39dde91eb6df").resolve("ccQi8"))
]).then(function() {
    return module.bundle.root('8M7QB');
});

},{"fa110917f8de966e":"fTgEh","2a9a39dde91eb6df":"aiVrJ","b6071a2c894768d9":"aJpgn"}],"e1Ewh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("8562488e70f0cd93")(require("b258df5331d1c1bc").resolve("9fikA")),
    require("8562488e70f0cd93")(require("b258df5331d1c1bc").resolve("lBKHP")),
    require("9f4f4c9e2c54fb4b")(require("b258df5331d1c1bc").resolve("7buS7"))
]).then(function() {
    return module.bundle.root('eciId');
});

},{"8562488e70f0cd93":"fTgEh","b258df5331d1c1bc":"aiVrJ","9f4f4c9e2c54fb4b":"aJpgn"}],"7NjCZ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("60ef3eede47cae73")(require("8c0d6f92495205f9").resolve("cSSie")),
    require("60ef3eede47cae73")(require("8c0d6f92495205f9").resolve("lBKHP")),
    require("28e3413202a19215")(require("8c0d6f92495205f9").resolve("8q3Qy"))
]).then(function() {
    return module.bundle.root('7M6kh');
});

},{"60ef3eede47cae73":"fTgEh","8c0d6f92495205f9":"aiVrJ","28e3413202a19215":"aJpgn"}],"cRTSJ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6fbdad4eda97b819")(require("7b562ee9c5cdc940").resolve("4E6mU")),
    require("6fbdad4eda97b819")(require("7b562ee9c5cdc940").resolve("lBKHP")),
    require("ecb12480d9677da0")(require("7b562ee9c5cdc940").resolve("k8q99"))
]).then(function() {
    return module.bundle.root('l4IgT');
});

},{"6fbdad4eda97b819":"fTgEh","7b562ee9c5cdc940":"aiVrJ","ecb12480d9677da0":"aJpgn"}],"dk30C":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("38c202b51b893178")(require("511c8f5f1c4fa5c6").resolve("g3iKU")),
    require("38c202b51b893178")(require("511c8f5f1c4fa5c6").resolve("lBKHP")),
    require("6fc2660ed3f61f84")(require("511c8f5f1c4fa5c6").resolve("bC8hb"))
]).then(function() {
    return module.bundle.root('d87m3');
});

},{"38c202b51b893178":"fTgEh","511c8f5f1c4fa5c6":"aiVrJ","6fc2660ed3f61f84":"aJpgn"}],"ihC5o":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("a01580fa2079b9c9")(require("ca529db9b2c3c660").resolve("e7lzp")),
    require("a01580fa2079b9c9")(require("ca529db9b2c3c660").resolve("lBKHP")),
    require("77a1eb66f4ba50ae")(require("ca529db9b2c3c660").resolve("esKh4"))
]).then(function() {
    return module.bundle.root('3b4eo');
});

},{"a01580fa2079b9c9":"fTgEh","ca529db9b2c3c660":"aiVrJ","77a1eb66f4ba50ae":"aJpgn"}],"kvdzY":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("87854fa0c4d43644")(require("defcbd642bd56c7a").resolve("6Iybm")),
    require("87854fa0c4d43644")(require("defcbd642bd56c7a").resolve("lBKHP")),
    require("ead77657c24c1f1c")(require("defcbd642bd56c7a").resolve("4c9dO"))
]).then(function() {
    return module.bundle.root('hK8TG');
});

},{"87854fa0c4d43644":"fTgEh","defcbd642bd56c7a":"aiVrJ","ead77657c24c1f1c":"aJpgn"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=module-context-provider.9c2b75de.js.map
